import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Amplify } from 'aws-amplify';
import theme from './utils/theme';

import PublicLayout from './components/PublicLayout';
import AdminLayout from './components/AdminLayout';
import RequireAuth from './components/RequireAuth';

import Home from './pages/public/Home';
import ArticleView from './pages/public/ArticleView';
import CategoryView from './pages/public/CategoryView';
import SearchResults from './pages/public/SearchResults';

import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import ArticleList from './pages/admin/ArticleList';
import ArticleEditor from './pages/admin/ArticleEditor';
import CategoryManager from './pages/admin/CategoryManager';
import MediaManager from './pages/admin/MediaManager';

// Amplify configuration will be loaded from amplifyconfiguration.json
try {
  const amplifyConfig = require('./amplifyconfiguration.json');
  Amplify.configure(amplifyConfig);
} catch {
  console.warn('Amplify configuration not found — run `amplify pull` to generate it');
}

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/article/:slug" element={<ArticleView />} />
            <Route path="/category/:slug" element={<CategoryView />} />
            <Route path="/search" element={<SearchResults />} />
          </Route>

          {/* Admin login */}
          <Route path="/admin/login" element={<Login />} />

          {/* Protected admin routes */}
          <Route
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/articles" element={<ArticleList />} />
            <Route path="/admin/articles/:id" element={<ArticleEditor />} />
            <Route path="/admin/categories" element={<CategoryManager />} />
            <Route path="/admin/media" element={<MediaManager />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
